
































// vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

// 组件
import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';

@Component({
  components: {
    TheHeader,
    TheFooter,
  },
  directives: {
    bgImg(el, options) {
      const imgURL = options.value;

      if (imgURL) {
        el.style.backgroundImage = `url(${options.value})`;
      } else {
        el.style.backgroundImage = `url()`;
      }
    },
  },
})
export default class App extends Vue {
  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  public hiddenHeader!: boolean;

  @Prop({
    type: Boolean,
    required: false,
    default: true,
  })
  public hiddenFooter!: boolean;

  @Prop({
    type: String,
    required: false,
    default: '',
  })
  public bgImg!: string;
}
